var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColtStangaJos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 111,
    viewBox: "0 0 102 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 0.5V55L101.75 54.4227",
    stroke: "black",
    strokeWidth: 4.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColtStangaJos);
export default __webpack_public_path__ + "static/media/colt_stanga_jos.945c82c1738aeece8a0d24977e685224.svg";
export { ForwardRef as ReactComponent };